module.exports = __webpack_public_path__ + "images/emoji/no_smoking.3b1af484821035d8f141.png";